// extracted by mini-css-extract-plugin
export default {"container":"style_container__Z1QoH","content":"style_content__4lHEr","grid":"style_grid__yA68-"};